
@if (showRefPopup) {
  <dx-popup [showTitle]="true" [width]="400" [height]="200" visible="true" title="Sessione in scadenza"
    [hideOnOutsideClick]="false" [showCloseButton]="false">
    <p style="text-align: center;">
      La sessione web sta scadendo, clicca per restare connesso.
      <br>
        <br>
          @if (countDownConfig) {
            <countdown #cd [config]="countDownConfig" (event)="countDownHandleEvent($event)" />
          }
          <br>
          </p>
          <p style="text-align: center;">
            <dx-button stylingMode="contained" text="Resta connesso" icon="redo" type="success"
              (onClick)="onRefreshSessionClick()">
            </dx-button>
          </p>
        </dx-popup>
      }
